import { render, staticRenderFns } from "./LottoCard.vue?vue&type=template&id=69f33134&scoped=true"
import script from "./LottoCard.vue?vue&type=script&lang=js"
export * from "./LottoCard.vue?vue&type=script&lang=js"
import style0 from "./LottoCard.vue?vue&type=style&index=0&id=69f33134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f33134",
  null
  
)

export default component.exports